import checkSocialApiMaintenance from 'common/configuration/social-api-maintenance-status';
import lazyModal from 'common/module/ui/lazy-modal';
import { SOCIAL_MAINTENANCE_MODAL } from 'common/module/ui/lazy-modal/constant-types';

/**
 * Opens the requested modal only when the social API is up, and the
 * maintenance modal instead — so the user is warned before typing content
 * (e.g. a long review) that could not be saved.
 */
const openUnlessSocialApiMaintenance = (
  modalName: string,
  params?: Record<string, unknown>
) =>
  checkSocialApiMaintenance().then(maintenanceActive => {
    if (maintenanceActive) {
      lazyModal.open(SOCIAL_MAINTENANCE_MODAL);
      return;
    }
    lazyModal.open(modalName, params);
  });

export default openUnlessSocialApiMaintenance;
